import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AtualizacoesAuditService extends BaseService<any> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/qrobras/audit';
  }

  public getAtualizacoes(obj: Object = null): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + '/atualizacoes', obj, { headers: this.headers });
  }

}